import { Component } from '@angular/core';

@Component({
  selector: 'app-sugarcane-quality',
  templateUrl: './sugarcane-quality.component.html',
  styleUrls: ['./sugarcane-quality.component.css']
})
export class SugarcaneQualityComponent {

  constructor() {

  }

  ngOnInit() {
    
  }


  onDateChange(e) {
  
  }

}

